module.exports = __webpack_public_path__ + "static/media/sg-text-logo.b31e026e.png";